import InfiniteScroll from '~/javascripts/components/InfiniteScroll';
import PrivacyToggle from '~/javascripts/components/LifetimeImpact/PrivacyToggle';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { useState } from 'react';

const Leaderboard = observer(
  ({
    classes,
    currentUser,
    currentUserStanding,
    dataUrl,
    hideHeader,
    infiniteScrollContainer,
    resourceId,
    signedInTeamMember,
    teamLeaderboard,
    teamLogo,
    teamName,
    totalMonthlyPeopleServed,
  }) => {
    const [showLifetimeImpact, setShowLifetimeImpact] = useState(
      currentUser ? currentUser.showLifetimeImpact : null
    );

    const headerText = () => {
      if (teamLeaderboard) {
        return `Meet the members of the ${teamName} team bringing clean water to people in need.`;
      } else {
        return `Meet some of the other Spring Members bringing clean water to ${totalMonthlyPeopleServed} people every single month!`;
      }
    };

    const showSignedInUserView = () =>
      (teamLeaderboard && signedInTeamMember) ||
      (!teamLeaderboard &&
        currentUser &&
        parseFloat(currentUser.lifetimeImpactTotal) > 0);

    const hideOrSuppressLifetimeImpact = () =>
      !showLifetimeImpact || currentUser.suppressLifetimeImpactForVip;

    return (
      <div
        className={`leaderboard border border-solid border-grey-30 mb-2 ${classes}`}
      >
        {!hideHeader && (
          <div className='leaderboard-header bg-cw-accent-200 mb-2 p-2 flex flex-col align-items text-center relative border-b border-solid border-0 border-grey-30'>
            {teamLeaderboard ? (
              <div
                className='logo m-auto'
                dangerouslySetInnerHTML={{ __html: teamLogo }}
              />
            ) : (
              <div className='leaderboard-eyebrow h80 text-strong-heading opacity-25 m-1'>
                Community
              </div>
            )}
            <p className='my-1 balance-text mx-auto font-granville text-base w-4/5'>
              {headerText()}
            </p>
            <div className='border-notch notch' />
            <div className='notch' />
          </div>
        )}
        {showSignedInUserView() && (
          <div
            className={cx(
              'current-user-standing border border-solid border-grey-30 rounded bg-grey-5 mx-1',
              {
                'private-lifetime-impact': hideOrSuppressLifetimeImpact(),
              }
            )}
          >
            <div className='flex justify-between items-center p-1'>
              <div className='flex items-center'>
                <span className='cw-icon-star mr-1' />
                <a
                  className='text-cw-black text-xs font-bold underline'
                  href={currentUser.publicProfileUrl}
                >
                  {currentUser.fullName}
                </a>
              </div>
              <div className='flex items-center'>
                <p className='text-xs text-grey-40 font-bold'>
                  {currentUserStanding}
                  {currentUserStanding && <span className='mx-1'>|</span>}
                </p>
                <p className='text-cw-green font-medium text-xs'>
                  {currentUser.formattedLifetimeImpactTotal}
                </p>
              </div>
            </div>
            {hideOrSuppressLifetimeImpact() && (
              <div className='flex bg-grey-10 w-full px-1 items-center border-t border-solid border-0 border-grey-30 text-grey-60 rounded-b'>
                <svg
                  fill='none'
                  height='17'
                  viewBox='0 0 17 17'
                  width='17'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M16.3756 7.89423C16.0265 6.95065 15.5499 6.05932 14.959 5.24506C14.8792 5.16201 14.7716 5.11132 14.6568 5.10269C14.542 5.09407 14.428 5.12812 14.3367 5.19833C14.2455 5.26853 14.1833 5.36995 14.1622 5.48314C14.1411 5.59633 14.1625 5.71334 14.2223 5.81173C14.7359 6.50395 15.1552 7.26143 15.469 8.06423C15.1431 8.87173 12.9898 13.6459 8.14481 13.6459C6.80828 13.6518 5.50064 13.257 4.39064 12.5126L6.04814 10.7984C6.64661 11.2703 7.3828 11.534 8.14481 11.5492C8.95955 11.5488 9.74902 11.2664 10.3791 10.7499C11.0092 10.2334 11.4411 9.5147 11.6015 8.71589C11.6039 8.60516 11.5668 8.49717 11.497 8.41119C11.4272 8.3252 11.3291 8.2668 11.2202 8.24639C11.1114 8.22597 10.9988 8.24488 10.9026 8.29973C10.8063 8.35458 10.7327 8.44182 10.6948 8.5459C10.5738 9.132 10.2538 9.6582 9.78898 10.0352C9.32418 10.4122 8.74327 10.6168 8.14481 10.6142V10.6142C7.63548 10.6094 7.14031 10.446 6.72814 10.1467L14.1798 2.73756C14.2435 2.64752 14.2734 2.53784 14.264 2.42792C14.2547 2.318 14.2068 2.21493 14.1288 2.13693C14.0508 2.05893 13.9477 2.01102 13.8378 2.00168C13.7279 1.99234 13.6182 2.02217 13.5281 2.08589L6.04814 9.4809C5.75803 9.065 5.60004 8.57129 5.59481 8.06423C5.56002 7.87218 5.56002 7.67544 5.59481 7.48339C5.70311 7.02544 5.93671 6.60665 6.26947 6.27389C6.60223 5.94113 7.02102 5.70753 7.47898 5.59923H7.81898C7.94297 5.59923 8.06188 5.54997 8.14955 5.4623C8.23722 5.37463 8.28648 5.25572 8.28648 5.13173C8.28648 5.00774 8.23722 4.88883 8.14955 4.80115C8.06188 4.71348 7.94297 4.66423 7.81898 4.66423H7.37981C6.74579 4.8131 6.1659 5.13595 5.70538 5.59647C5.24487 6.05698 4.92201 6.63687 4.77314 7.27089C4.69976 7.52902 4.66164 7.79588 4.65981 8.06423C4.67903 8.81882 4.93694 9.5479 5.39648 10.1467L2.13814 13.3909C2.09445 13.4332 2.0597 13.4838 2.03596 13.5398C2.01223 13.5958 2 13.6559 2 13.7167C2 13.7775 2.01223 13.8377 2.03596 13.8937C2.0597 13.9497 2.09445 14.0003 2.13814 14.0426C2.22473 14.1296 2.34128 14.1803 2.46398 14.1842C2.58667 14.1803 2.70322 14.1296 2.78981 14.0426L3.66814 13.1642C3.66814 13.1642 3.66814 13.1642 3.66814 13.2351C4.98589 14.133 6.55051 14.5985 8.14481 14.5667C14.1231 14.6517 16.4323 8.33339 16.4606 8.27673C16.4677 8.20607 16.4677 8.13489 16.4606 8.06423C16.4483 8.00088 16.4189 7.94209 16.3756 7.89423Z'
                    fill='#71716C'
                  />
                  <path
                    d='M2.47918 10.7525C1.95263 10.0614 1.5192 9.30407 1.19001 8.5C1.57251 7.57917 3.72584 2.91834 8.50001 2.91834C9.16112 2.91527 9.81933 3.00589 10.455 3.1875C10.5715 3.22132 10.6966 3.20748 10.8029 3.14903C10.9092 3.09058 10.9879 2.99231 11.0217 2.87584C11.0555 2.75936 11.0417 2.63423 10.9832 2.52796C10.9248 2.42169 10.8265 2.34299 10.71 2.30917C9.99128 2.102 9.24795 1.9924 8.50001 1.98334C2.57834 1.98334 0.283344 8.2875 0.255011 8.34417C0.220396 8.45002 0.220396 8.56415 0.255011 8.67C0.619249 9.62513 1.12032 10.5223 1.74251 11.3333C1.78713 11.3886 1.8431 11.4337 1.90665 11.4655C1.9702 11.4972 2.03984 11.515 2.11084 11.5175C2.21294 11.5128 2.31142 11.4783 2.39418 11.4183C2.44428 11.3808 2.48633 11.3336 2.51783 11.2795C2.54934 11.2254 2.56966 11.1655 2.57759 11.1034C2.58551 11.0413 2.58089 10.9782 2.56398 10.918C2.54708 10.8577 2.51824 10.8014 2.47918 10.7525V10.7525Z'
                    fill='#71716C'
                  />
                </svg>

                <p className='ml-1 text-xs'>Only visible to you</p>
              </div>
            )}
          </div>
        )}
        <InfiniteScroll
          dataUrl={dataUrl}
          infiniteScrollContainer={infiniteScrollContainer}
          key={showLifetimeImpact}
          resourceId={resourceId}
        />
        {showSignedInUserView() && hideOrSuppressLifetimeImpact() && (
          <div className='leaderboard-footer bg-cw-accent-200 p-2 border-t border-solid border-0 border-grey-30'>
            <div className='flex flex-row justify-center items-start'>
              <div className='flex flex-col text-left'>
                <div className='flex flex-row'>
                  <i className='icon cw-icon-warning-sign text-cw-red text-sm pr-2' />
                  <div>
                    <h2 className='h70'>
                      Your name is currently <span className='italic'>not</span>{' '}
                      displayed publicly.
                    </h2>
                    {!currentUser.suppressLifetimeImpactForVip && (
                      <p className='p40 mt-1 mb-2'>
                        Change your setting to public to appear on the community
                        board.
                      </p>
                    )}
                  </div>
                </div>
                {!currentUser.suppressLifetimeImpactForVip && (
                  <div className='border border-dashed border-l-0 border-r-0 border-b-0 border-grey-30'>
                    <div className='flex flex-row items-center justify-between pt-1'>
                      <h2 className='h80 text-strong-heading text-grey-50 mb-0'>
                        Your current setting
                      </h2>
                      <PrivacyToggle
                        setShowLifetimeImpact={setShowLifetimeImpact}
                        showLifetimeImpact={showLifetimeImpact}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default Leaderboard;
